module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-superiority.011a200d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-bottom-superiority.png
// module id = 2847
// module chunks = 11